import { Drawer, Form, Input } from 'antd';
import clsx from 'clsx';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
import uuid from 'utils/uuid';
import ActionsStep from './ActionsStep';
import { IGroupCustomerItem } from './types';
export type ICustomerEditorFormData = {
  customerName: string;
  numCustomers: number;
  customers: IGroupCustomerItem[];
};
type CustomerBottomSheetProps = {};
type CustomerBottomSheetRef = {
  open: (data: Partial<ICustomerEditorFormData>) => Promise<ICustomerEditorFormData | null>;
};
export const customerBs = React.createRef<CustomerBottomSheetRef>();
const CustomerBottomSheet = forwardRef<CustomerBottomSheetRef, CustomerBottomSheetProps>((_, ref) => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const callbackRef = useRef<(data: ICustomerEditorFormData | null) => void>(() => undefined);

  const handleFinish = (values: any) => {
    const body = values as ICustomerEditorFormData;
    setOpen(false);
    callbackRef.current(body);
  };

  const onClose = () => {
    callbackRef.current(null);
    setOpen(false);
  };

  useImperativeHandle(ref, () => ({
    open: async (data: Partial<ICustomerEditorFormData>) => {
      form.resetFields();
      form.setFieldValue('numCustomers', data.numCustomers || 1);
      form.setFieldsValue(data);
      if (!data.customers) {
        onChangeNumCustomers(data);
      }
      setOpen(true);
      return new Promise<ICustomerEditorFormData | null>((resolve) => {
        callbackRef.current = resolve;
      });
    },
  }));

  const onChangeNumCustomers = (data: Partial<ICustomerEditorFormData>) => {
    const customerList: IGroupCustomerItem[] = [{ name: data.customerName || form.getFieldValue('customerName') || '', uuid: uuid(), requestStaff: true, services: [] }];
    Array((data.numCustomers || 1) - 1).fill('').map(() => {
      customerList.push({ name: '', uuid: uuid(), requestStaff: true, services: [] });
    });
    form.setFieldValue('customers', customerList);
  };

  return (
    <>
      <Drawer contentWrapperStyle={{
        padding: 0, maxWidth: '476px',
        margin: '0 auto',
      }} bodyStyle={{ padding: 0 }} height={'80vh'} width={'476px'} placement="bottom" closable={false} onClose={onClose} open={open}>
        <Container layout='vertical' form={form} onFinish={handleFinish}>
          <div className="title-select">Number Customers</div>
          <Form.Item name={'customerName'} noStyle />
          <Form.Item name={'numCustomers'} noStyle>
            <NumberCustomerBox onChange={(num) => onChangeNumCustomers({ numCustomers: num })} />
          </Form.Item>
          <CustomerListInput />
        </Container>
        <ActionsStep onClose={onClose} onOk={() => form.submit()} />
      </Drawer>
    </>
  );
});
CustomerBottomSheet.displayName = 'CustomerBottomSheet';
export default CustomerBottomSheet;

const Container = styled(Form)`
min-height: 90vh;
padding: 16px;
.title-select {
  position: sticky;
  top: 0;
  background:#fff;
  padding: 8px 0;
  z-index: 22;
  color: #232F3E;
  text-align: center;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.48px;
}
`;

type NumberCustomerBoxProps = {
  value?: number;
  onChange?: (value?: number) => void;
};
const NumberCustomerBox = ({ value, onChange }: NumberCustomerBoxProps) => {
  return (
    <ContainerNumberCustomerBox>
      <button onClick={() => onChange?.(1)} type='button' className={clsx('box-number-item', value?.toString() === '1' && 'active')}><span>1</span></button>
      <button onClick={() => onChange?.(2)} type='button' className={clsx('box-number-item', value?.toString() === '2' && 'active')}><span>2</span></button>
      <button onClick={() => onChange?.(3)} type='button' className={clsx('box-number-item', value?.toString() === '3' && 'active')}><span>3</span></button>
      <button onClick={() => onChange?.(4)} type='button' className={clsx('box-number-item', value?.toString() === '4' && 'active')}><span>4</span></button>
      <button onClick={() => onChange?.(5)} type='button' className={clsx('box-number-item', value?.toString() === '5' && 'active')}><span>5</span></button>
      <button onClick={() => onChange?.(6)} type='button' className={clsx('box-number-item', value?.toString() === '6' && 'active')}><span>6</span></button>
      <button onClick={() => onChange?.(7)} type='button' className={clsx('box-number-item', value?.toString() === '7' && 'active')}><span>7</span></button>
      <button onClick={() => onChange?.(8)} type='button' className={clsx('box-number-item', value?.toString() === '8' && 'active')}><span>8</span></button>
      <button onClick={() => onChange?.(9)} type='button' className={clsx('box-number-item', value?.toString() === '9' && 'active')}><span>9</span></button>
      <button onClick={() => onChange?.(10)} type='button' className={clsx('box-number-item', value?.toString() === '10' && 'active')}><span>10</span></button>
      <button onClick={() => onChange?.(11)} type='button' className={clsx('box-number-item', value?.toString() === '11' && 'active')}><span>11</span></button>
      <button onClick={() => onChange?.(12)} type='button' className={clsx('box-number-item', value?.toString() === '12' && 'active')}><span>12</span></button>
    </ContainerNumberCustomerBox>
  );
};

const ContainerNumberCustomerBox = styled.div`
display: grid;
padding: 12px;
grid-template-columns: repeat(4, 1fr);
align-items: flex-start;
gap: 12px;
align-self: stretch;
border-radius: 8px;
background: #F6F7FC;
  .box-number-item {
    display: flex;
    height: 60px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0 0;
    border-radius: 4px;
    border: 1px solid #E9EDF2;
    background: #FFF;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.10);
    span {
      color: #1D2129;
      text-align: center;
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
        
    &.active {
      border: 1px solid #E9EDF2;
      background: #2463EB;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.10);
      span {
        color: #fff;
      }
    }

  }
`;

type CustomerListInputProps = {
  value?: number;
  onChange?: (value?: number) => void;
};
const CustomerListInput = ({ }: CustomerListInputProps) => {
  return (
    <ContainerCustomerListInput>
      <Form.List name={'customers'}>
        {
          (fields) => {
            return (
              <>
                {fields.map((field, index) => {
                  return (
                    <Form.Item label={`Customer name #${index + 1}`} key={field.key} name={[field.name, 'name']} rules={[{ required: true, message: 'Please input customer name' }]}>
                      <InputName />
                    </Form.Item>
                  );
                })}
              </>
            );
          }
        }
      </Form.List>

    </ContainerCustomerListInput>
  );
};

const ContainerCustomerListInput = styled.div`
  .ant-form-item .ant-form-item-label {
    padding: 0;
    label {
      color: #1D2129;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      &::before {
        content: '' !important;
      }
    }
  }
`;

const InputName = styled(Input)`
  display: flex;
  height: 56px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.5px;
`;
